/*
 * Search zero-results state.
 *
 * A search filtered down to nothing looks identical to a search that never
 * matched, and Shopify gives the server no way to tell them apart: once a
 * search returns zero results, the applied values disappear from
 * filter.active_values, so the chip row comes back empty too. The URL is
 * the only surviving evidence, so the distinction is drawn here.
 *
 * One class on .template-search drives every reveal; CSS owns which
 * elements that shows and hides. The filter drawer replaces the grid's
 * innerHTML on each AJAX fetch, so we re-run on the productGridUpdated
 * event it already broadcasts (the same seam infinite-scroll.js uses)
 * rather than reaching into that module.
 */
(function () {
  const FILTERED_CLASS = 'is-zero-filtered';
  const root = document.querySelector('.template-search');
  if (!root) return;

  function sync() {
    const filtered = [...new URLSearchParams(window.location.search).keys()].some((key) =>
      key.startsWith('filter.')
    );
    root.classList.toggle(FILTERED_CLASS, filtered);
  }

  sync();
  document.addEventListener('productGridUpdated', sync);
  window.addEventListener('popstate', sync);
})();
